(function ($) {
	$(() => {

		if ($('#calendar').length) {

			$('#calendar').fullCalendar({
				defaultView: $(window).width() > 768 ? 'month' : "listMonth",
				header: {
					left: 'prev',
					center: 'title',
					right: 'next'
				},
				defaultDate: moment(),
				views: {
					month: {
						titleFormat: 'MMMM',
						columnFormat: 'dddd'
					}
				},
				locale: 'hu',
				editable: false,
				selectable: false,
				selectHelper: false,
				nowIndicator: true,
				timeFormat: 'H:mm',
				displayEventEnd: true,
				windowResize: function(view) {
					if ($(window).width() > 768){
						$('#calendar').fullCalendar( 'changeView', 'month' );
					} else {
						$('#calendar').fullCalendar( 'changeView', 'listMonth' );
					}
				},
				events: {
					url: localize.ajaxurl,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'get_events'
					},
					success: function (events) {
						var eventsArray = [];
						$(events).each(function () {
							eventsArray.push({
								title: $(this).attr('title'),
								allDay: $(this).attr('allDay'),
								start: $(this).attr('start'),
								end: $(this).attr('end'),
								url: $(this).attr('url')
							});
						});
					},
					error: function () {
						console.log('error while fetching events');
					}
				}
			});
		}

		if($('.related-gallery').length){
			// gallery init
			$('.related-gallery').lightGallery({
				selector: '.gallery-item',
				thumbnail: true,
				currentPagerPosition: 'left',
				thumbMargin: 10,
				mousewheel: true,
				autoplay: false,
				download: false,
				fullScreen: false,
				pager: false,
				zoom: false,
				hash: false,
				share: false
			});
		}
	});
})(jQuery);